const escapeHtml = (value: string): string =>
	String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');

export const formatSpellCheckResult = (text: string): string => {
	return escapeHtml(text)
		.replace(/\*\*([^*]+)\*\*/g, (_, m) => `<mark>${m}</mark>`)
		.replace(/\n/g, '<br /><br />');
};

/** Форматирует текст фактчекинга: `**…**` → `<strong>`, переносы → `<br />`. */
export const formatFactCheckingResult = (text: string): string => {
	return escapeHtml(text)
		.replace(/\*\*([^*]+)\*\*/g, (_, m) => `<strong>${m}</strong>`)
		.replace(/\n/g, '<br />');
};



// WEBPACK FOOTER //
// src/util/spell-check.js